import { Validator } from '@vista-digital/validator';
import { CaptchaType } from '../../../types/type';
import { googleRecaptchaV2SizeValidator } from './size';
import { googleRecaptchaV2ThemeValidator } from './theme';
export const googleRecaptchaV2ConfigValidator = Validator.object({
    type: Validator.isEqualTo(CaptchaType.GoogleRecaptchaV2),
    siteKey: Validator.nonEmptyString,
    size: Validator.optional(googleRecaptchaV2SizeValidator),
    theme: Validator.optional(googleRecaptchaV2ThemeValidator)
});
//# sourceMappingURL=config.js.map